import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Disable navigator.locks (causes hangs on some deployments)
const lockNoOp = async (_name, _acquireTimeout, fn) => await fn();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { lock: lockNoOp },
});
